"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var styledComponents_1 = require("./styledComponents");
var LoaderWithText = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement(styledComponents_1.StyledContainer, null,
        react_1.default.createElement(styledComponents_1.StyledText, null, text),
        react_1.default.createElement(styledComponents_1.StyledLoader, null)));
};
LoaderWithText.propTypes = {
    text: prop_types_1.default.string,
};
LoaderWithText.defaultProps = {
    text: 'Loading...',
};
exports.default = LoaderWithText;
